import {PropsWithChildren} from "react";
import Box from "@mui/material/Box";

export const Body = (props: PropsWithChildren) => {
    return (<Box component="main">{props.children}</Box>)
}